<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Payment Credential </strong>
            <small>Form</small>
          </div>
          <b-form ref="popupform">
            <b-row>
              <div class="col-lg-6 col-xl-6 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pageForm.cinema_selected"
                    :options="CinemasList"
                    track-by="cinema_id"
                    label="cinema_name"
                    @select="onChangeCinema"
                    @remove="onChangeCinema"
                    :multiple="false"
                    placeholder="Select Cinema"
                  ></multiselect>
                </b-form-group>
              </div>

              <div class="col-lg-6 col-xl-6 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="payment_array"
                    :multiple="false"
                    track-by="pm_id"
                    label="pm_payment_mode"
                    placeholder="Select Payment Mode"
                    @select="onChangePayment"
                    v-model="pageForm.payment_obj"
                  ></multiselect>
                </b-form-group>
              </div>

              <template v-if="Object.keys(sendPayload.Credential).length">
                <template v-for="item in Object.keys(sendPayload.Credential)">
                  <div
                    class="col-lg-12 col-xl-12 align-self-center mb-4"
                    :key="'dd' + item"
                  >
                    <b-form-group>
                      <div class="input-material mt-2">
                        <b-form-input
                          type="text"
                          v-model="sendPayload.Credential[item]"
                          placeholder=""
                        ></b-form-input>
                        <label>{{ item }}</label>
                      </div>
                    </b-form-group>
                  </div>
                </template>
              </template>

              <!-- 
              <div class="input-material-textarea">
                <div class="col-lg-12 align-self-center mb-4">
                  <div class="descriptionSection font-weight-bold fs-14 mb-3">
                    Description
                  </div>
                  <div class="" >
                    <vue-editor
                      v-model="pageForm.description"
                      name="page"
                      id="page"
                    ></vue-editor>
                  </div>
                </div>
              </div> -->
            </b-row>

            <b-row class="m-2">
              <b-col sm="4">
                <b-button size="sm" variant="primary" @click="onFinalSubmit">
                  <i class="fa fa-dot-circle-o"></i>
                  Update
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        title="See Images"
        ref="showImages"
        @ok="onOkay"
      >
        <div>
          <draggable
            v-model="bannerImg"
            ref="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              sm="4"
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
            >
              <img :src="BASE_URL + item" style="width:100px;height:100px" />
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>

    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'image'"
        class="img-fluid"
      />
      <video
        autoplay
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'video'"
        class="img-fluid"
      />
    </b-modal>

    <b-modal
      id="imagecropper"
      title="Crop Image"
      hide-footer
      no-close-on-backdrop
    >
      <button
        class="btn-clearDate text-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>

      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { VueEditor } from "vue2-editor";
import VueCropper from "vue-cropperjs";
import signageServices from "@/services/signageService";

import "cropperjs/dist/cropper.css";

export default {
  name: "AddPopupPages",
  data() {
    return {
      editMode: false,
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      Ratings: [],
      isEdit: true,
      staticNames: {
        name: "Add"
      },
      modalObject: {
        title: "fdsfds"
      },
      cinemaListArray: [],
      popupType: 0,
      countryOptions: [],
      LanguageArray: [],
      typeArray: [
        { type_id: 1, type_name: "Schedule" },
        { type_id: 2, type_name: "Offer" },
        { type_id: 3, type_name: "Upcoming Movies" }
      ],
      orientationArray: [
        { o_type_id: 1, o_type_name: "Horizontal" },
        { o_type_id: 2, o_type_name: "Vertical" }
      ],
      pagesList: {
        pp_id: "",
        mpm_id: "",
        main_name: "",
        country_id: "",
        description: "",
        language: "",
        popup_rating_url: "",
        isActive: false,
        popup_rating_title: "",
        banner: "",
        status: "Y",
        ratingType: ""
      },
      error: {
        mpm_id_error_msg: false,
        main_name_error_msg: false,
        country_id_error_msg: false,
        description_error_msg: false,
        language_error_msg: false,
        popup_rating_url_error_msg: false,
        isActive_error_msg: false,
        popup_rating_title_error_msg: false,
        banner_error_msg: false,
        status_error_msg: false,
        ratingType_error_msg: false
      },
      imageSize: {
        width: 125,
        height: 125
      },

      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: [],
      CinemasList: [],
      payment_array: [],
      CinemasListCopy: [],
      pageForm: {
        cinema_selected: "",
        payment_obj: "",

        theme_type: "Red Theme"
      },
      sendPayload: {
        mpcc_id: "",
        Credential: {}
      },

      Url: [
        {
          selected_url: "",
          selected_type: "",
          uploadPercentage: 0
        }
      ],
      theme_array: ["Red Theme", "Black Theme"],
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      tempModalImageName: null,
      tempModalImagePath: null,
      tempContentType: "",
      CredentialArray: []
    };
  },
  components: {
    VueEditor,
    draggable,
    VueCropper
  },
  computed: {},
  watch: {},
  async beforeMount() {
    if (true) {
      this.isRoleID = false;
    }

    // this.getAllActiveScreens();
    this.getPaymentCredential();
  },
  mounted: function() {},
  methods: {
    onChangeCinema() {
      setTimeout(z => {
        this.onChangePayment(this.pageForm.payment_obj);
      });
    },
    onChangePayment(event) {
      this.sendPayload.mpcc_id = "";
      this.sendPayload.Credential = {};
      if (
        this.pageForm.cinema_selected &&
        this.pageForm.cinema_selected.cinema_id &&
        event.pm_id
      ) {
        let cinema_id = this.pageForm.cinema_selected.cinema_id;

        let credential2 = this.CredentialArray.filter(z => {
          return z.cinema_id == cinema_id && z.pm_id == event.pm_id;
        });
        console.log(
          "credential2",
          this.CredentialArray,
          cinema_id,
          credential2
        );

        if (credential2.length > 0) {
          this.sendPayload.mpcc_id = credential2[0].mpcc_id;
          this.sendPayload.Credential = JSON.parse(credential2[0].Credential);
        }
      }
    },
    onFinalSubmit() {
      if (!this.pageForm.cinema_selected) {
        this.$toasted.show("Please Select Cinema");
        return false;
      }

      if (!this.pageForm.payment_obj) {
        this.$toasted.show("Please Select Payment Obj");
        return false;
      }

      if (!this.sendPayload.mpcc_id) {
        this.$toasted.show("No Credential Found");
        return false;
      }

      let loader = this.$loading.show();
      let payload = {
        ...this.sendPayload
      };
      console.log(payload);
      signageServices.updatePaymentCredential(payload).then(response => {
        const { data } = response;
        loader.hide();

        if (data && data.status) {
          this.$toasted.show(data.message);
          this.getPaymentCredential();
        } else {
          // Show Error message
          this.$toasted.show(data.message);
        }
      });
    },
    cropImage() {
      this.$bvModal.hide("imagecropper");

      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    onThumbnailUpload: function(image, filename, index) {
      let loader = this.$loading.show();

      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Signage Image");
      let JWT = window.localStorage.getItem("JWT_TOKEN");
      const options = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: JWT,
          "Access-Control-Allow-Origin": "*"
        },
        onUploadProgress: event => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        }
      };
      MasterService.GlobalUploadImage(formData, options)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    hideCropperModal: function(modal) {
      this.$bvModal.hide("imagecropper");
    },
    addGeneric: function() {
      this.Url.push({
        selected_url: "",
        selected_type: "",
        uploadPercentage: 0
      });
    },
    removeGeneric: function(index) {
      this.Url.splice(index, 1);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    openImageModal: function(name, path, type) {
      this.tempModalImagePath = path;
      this.tempModalImageName = name;
      this.tempContentType = type;
      this.$refs["preview-modal"].show();
    },
    //Set Image
    setImage: function(e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;

      if (this.file.type.indexOf("image/") !== -1) {
        this.Url[index].selected_type = "image";

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            this.imgSrc = event.target.result;
            this.width = 129;
            this.height = 192;
            // this.$cropper.setAspectRatio(1);
            // rebuild cropperjs with the updated source
            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      } else if (this.file.type.indexOf("video/") !== -1) {
        this.Url[index].selected_type = "video";

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            this.imgSrc = event.target.result;

            this.VideoFilter();
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      } else {
        this.$toasted.show("Please select an Image file OR Video File.");
        return;
      }
    },
    VideoFilter() {
      var block = this.imgSrc.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.OnVideoUpload(blob1, this.filename, this.indexofthubmnail);
    },
    OnVideoUpload: function(video, filename, index) {
      this.load;

      let formData = new FormData();
      formData.append("video", video, filename);
      formData.append("videoPath", "Generic Signage");

      const options = {
        headers: {
          "content-type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*"
        },
        onUploadProgress: event => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        }
      };

      MasterService.GlobalUploadVideo(formData, options)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          console.log("this.uploadpercent", this.uploadPercentage);
        });
    },
    getSignageList(display_id) {
      let loader = this.$loading.show();
      let payload = {
        limit: 10,
        currentPage: 1,
        display_id
      };
      this.SignageDisplayArray = [];
      signageServices
        .getDisplaySignage(payload)
        .then(response => {
          const { data } = response;
          loader.hide();
          if (data.status) {
            if (
              data.Records.hasOwnProperty("data") &&
              data.Records.data.length > 0
            ) {
              let new_data = data.Records.data[0];
              this.pageForm = {
                cinema_selected: this.CinemasList.filter(z => {
                  return z.cine_id == new_data.cinema_id;
                })[0],
                display_id: new_data.display_id,
                display_name: new_data.display_name,
                display_height: new_data.display_height,
                display_width: new_data.display_width,
                type_selected: JSON.parse(new_data.type_array),
                description: new_data.description,
                orientation_type: this.orientationArray.filter(z => {
                  return z.o_type_name == new_data.orientation_type;
                })[0],
                sliderInSec: new_data.slider_timer,
                theme_type: new_data.theme_type
              };
              this.Url = JSON.parse(new_data.extra_image_video_play);
            } else {
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {});
    },

    getPaymentCredential: function() {
      signageServices
        .getPaymentCredential()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.CinemasList = data.cinema_array;
            this.payment_array = data.payment_array;
            this.CredentialArray = data.credential;
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },

    onOkay() {
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][
          this.bannerType
        ] = this.bannerImg.join(",");
      }
    },

    getLanguagesList: function() {
      // getCountriesList

      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      return MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            //console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            //console.log("Error from language", data.message);
          }
        })
        .catch(error => {
          //console.log(error, "from language catch");
        });
    },

    openModal: function(ref) {
      this.$refs[ref].show();
    },
    closeModal: function(ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End

    validateData() {},
    submitFinalData() {
      if (this.validateData()) {
      }
    }
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/NewSignage/payment_credential.vue